import {DecodedJwtToken} from '../_data/admin/jwt-token';
import {isUserObject} from './type-guards';

export function maxTokenAgeMillis(jwt: DecodedJwtToken): number {
  return expiryTimestampMillis(jwt) - initializedTimestampMillis(jwt);
}

export function initializedTimestampMillis(jwt: DecodedJwtToken): number {
  return (jwt?.iat ?? 0) * 1000;
}

export function expiryTimestampMillis(jwt: DecodedJwtToken): number {
  return (jwt?.exp ?? 0) * 1000;
}

export function expiryMillisFromNow(jwt: DecodedJwtToken): number {
  return expiryTimestampMillis(jwt) - Date.now();
}

export function parseUser(jwt) {
  const parsedUser = isUserObject(jwt.user) ? jwt.user : JSON.parse(jwt.user);
  Object.assign(jwt, {user: parsedUser});
  return jwt;
}
